export const BOARD = 'BOARD' as const;
export const BACKLOG = 'BACKLOG' as const;
export const ROADMAPS = 'ROADMAPS' as const;
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const UNKNOWN = 'UNKNOWN' as const;

type CacheInvalidationType = typeof BOARD | typeof BACKLOG | typeof ROADMAPS | typeof UNKNOWN;

type Resource = {
	refresh: () => void;
	update: (arg1: () => null) => void;
	clear: () => void;
};

export type ResourcesDictionary = {
	current: Record<CacheInvalidationType, Resource>;
};
